import Delete from "../../../../../shared/Icons/Delete";
import Activities from "../../../hooks/Levels/Activities";
import EquivalentActivitiesAndBenefit from "./Columns/EquivalentActivitiesAndBenefit";
import LevelAndPointsRange from "./Columns/LevelAndPointsRange";
import AsyncButton from "../../../../../shared/Loading/AsyncButton";

const LevelCard = (props) => {  
  const vm = Activities({row: props.row, setLevels: props.setLevels})

  return (
    <div className={`relative rounded-lg border border-gray-300 p-4 shadow-sm
    ${props.isEditor ? 'bg-gray-100' : 'bg-white'}`}>
      {props.isEditor && (
        <AsyncButton light
          onClick={() => props.deleteLevel(props.row.Id)}
          className="absolute right-3 -mt-2 text-red-500 hover:bg-red-50 rounded transition"
          title="Eliminar nivel"
        >
          <Delete />
        </AsyncButton>
      )}
      <LevelAndPointsRange 
        theme={props.theme}
        row={props.row}
        isEditor={props.isEditor}
        setLevels={props.setLevels}
        updateImage={props.updateImage}
        getImageUrl={props.getImageUrl}
        inputClassName={props.inputClassName}
      />
      <EquivalentActivitiesAndBenefit
        row={props.row}
        isEditor={props.isEditor}
        setLevels={props.setLevels}
        setActivities={vm.setActivities}
        deleteActivity={props.deleteActivity}
        handleAddActivity={vm.handleAddActivity}
      />
    </div>
  );
};

export default LevelCard;
